<template>
  <v-form @submit.prevent="checkPromoCode" ref="promoCodeForm" class="mt-10">
    <v-card class="elevation-12 mb-5">
      <v-toolbar
          color="#488ba6"
          dark
          flat

      >
        <v-toolbar-title>Discounts</v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-text-field
            label="Enter a valid promo code here"
            v-model="promoCodeText"
            type="text"
            name="promoCode"
            attach
        ></v-text-field>
        <v-btn
            color="#488ba6"
            type="submit"
            style="color:white"
            :disabled="verifiedPromoCode.PROMOID > 0"
        >
          Submit
        </v-btn>
        <v-alert class="mt-2" type="warning" v-if="promoLastSent && !verifiedPromoCode.PROMOID">
          Promo code: {{ promoLastSent }} is not valid. <br><br>
          If you are experiencing an error please call (904) 309-6268, or email debug@fvs.org
        </v-alert>
        <div v-else-if="verifiedPromoCode.PROMOID">
          <v-alert class="mt-2" type="success" >
            Promo code applied to your order!<br>
            Code: {{ verifiedPromoCode.code }}<br>
            {{ verifiedPromoCode.description }}
          </v-alert>
        </div>

      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "PromoCode",
  data: function () {
    return {
      promoCodeText: "",
      promoLastSent: ""
    }
  },
  computed: {
    ...mapState({
      verifiedPromoCode: state => state.payment.promoCode
    }),
  },
  methods: {
    checkPromoCode: function () {
      this.$store.dispatch("lookupPromoCode", this.promoCodeText).then(
          () => {
            this.promoLastSent = this.promoCodeText;
          }
      );

    }
  }
}
</script>

<style scoped>

</style>